<template>
  <div style="height: 60px; line-height:50px; border-bottom: 1px solid #617173; display: flex;">
    <img src="../assets/logo1.png" alt="Logo" style="width: 170px; height: auto; margin-bottom: 15px;margin-left: 60px">
    <div style="width:800px;
         padding-left: 300px;
         color: #617173;
         font-family:'Yuanti SC',serif;
         font-size: 32px;
         letter-spacing: 10px">
      華夏青年中醫協會
    </div>
  </div>
</template>

<script>

export default {
  name: "Header",
  props: ['user'],
  data() {
    return {
    }
  },
  //控制因身份不同而改变样式的侧边栏
  created() {
    // //从缓存中获取信息
    // let userStr = sessionStorage.getItem("user") || "{}"
    // //从网页中获取到JSON串之后转化成user对象，基于user对象然后进行判断
    // this.user = JSON.parse(userStr)
  },
  methods: {

  },
}
</script>

<style scoped>

</style>
